<template>
  <div class="equity-card-page">
    <top-bar :topbarList="equityCardTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { equityCardIndexMixins } from "@/mixins/equityCardIndexMixins";

export default {
  mixins: [equityCardIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.equity-card-page {
  height: 100%;
}
</style>
